export default __webpack_public_path__ + "707927cae5043a4aa95c38d6a02a852e.jpg";